import { Box } from "@chakra-ui/layout";
import PropTypes from "prop-types";
import { Line } from "react-chartjs-2";
import { theme } from "../theme.config";
import { formatCurrency } from "../helpers/number.helpers";

export const LoanCalculationChart = ({
  payments,
  remainingLabel,
  language,
}) => {
  const actualPayments = [...payments].slice(1);

  const paymentsAsChartData = actualPayments.map((payment) => {
    return payment.remaining;
  });
  const paymentsAsLabels = actualPayments.map((_, index) => {
    return String(index + 1);
  });

  const settings = {
    data: {
      labels: paymentsAsLabels,
      datasets: [
        {
          label: remainingLabel,
          data: paymentsAsChartData,
          borderColor: theme.colors.orange["500"],
          backgroundColor: theme.colors.orange["200"],
          fill: true,
        },
      ],
    },
    options: {
      scales: {
        y: {
          ticks: {
            callback(value) {
              if (language === "sv") {
                return formatCurrency(value, " ");
              }

              if (language === "dk") {
                return Number(value).toLocaleString("da");
              }

              return Number(value).toLocaleString();
            },
          },
        },
      },
    },
  };

  return (
    <Box paddingBottom="10">
      <Line {...settings} />
    </Box>
  );
};

LoanCalculationChart.propTypes = {
  payments: PropTypes.arrayOf({
    calcPayment: PropTypes.number,
    payment: PropTypes.number,
    interestCost: PropTypes.number,
    fees: PropTypes.number,
    amortization: PropTypes.number,
    remaining: PropTypes.number,
  }),
  remainingLabel: PropTypes.string,
};
